<template>
  <div class="ShunHe">
    <!-- 秋季：7-9月 -->
    <div class="autumn">
      <div class="banner">
        <img width="100%" src="../../../assets/img/ShunHe/autumn_banner.jpg" alt="" srcset="">
      </div>
      <div class="con1">
        <div class="con1_leftBox">
          <img width="100%" src="../../../assets/img/ShunHe/autumn_lipingPic.png" alt="" srcset="">
        </div>
        <div class="con1_rightBox">
          <div class="top_title">
            <div style="display: flex;justify-content: center;align-items: center;">
              <img style="margin-right:5px;" src="../../../assets/img/ShunHe/autumn_square.png" alt="" srcset="">
              <span>简介</span>
            </div>
            <!-- <span style="display:block">>></span> -->
          </div>
          <div class="cont">
            <p>
              “寻南山”，意为上南山，寻核桃。我们不仅要寻找优质原生态薄壳核桃，更要寻找当地人自强不息，通过发展核桃产业脱贫致富的精神，寻找不忘初心，不辱使命的扶贫工作干部的足迹。通过他们不懈努力，帮助该村摆脱了贫困面貌，让这种自强不息，不忘党恩的精神永远发扬传承下去!
              <!-- “寻南山”，意为上南山，寻核桃。我们不仅要寻找优质原生态薄壳核桃，更要寻找南山人自强不息，通过发展核桃产业脱贫致富的精神；更要寻找不忘初心，不辱使命的扶贫工作干部的足迹，通过他们不懈努力，帮助南山村摆脱了贫困面貌。让这种自强不息，不忘党恩的精神永远发扬传承下去! -->
            </p>
            <p>
              “寻南山”，核桃地处干热新河谷地带的大渡河大峡谷境内，常年光照充足，盛产优质核桃。所生产的核桃皮薄，果仁饱满，鲜核桃鲜、香、嫩，口感很佳，该产业带动了村经济发展，是巩固脱贫攻坚成效的支柱产业。
              <!-- “寻南山”，核桃地处汉源县顺河彝族乡南山村境内，由于地处干热新河谷地带的大渡河大峡谷境内，常年光照充足，盛产优质核桃。所生产的核桃皮薄，果仁饱满。鲜核桃鲜、香、嫩，口感很佳，该产业带动顺河村经济发展，是巩固脱贫攻坚成效的支柱产业。 -->
            </p>
            <div style="width:100%;margin-top:10px;">
              <img style="width:100%;float:right;" src="../../../assets/img/ShunHe/autumn_jianjiePic.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 便民 -->
      <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/ShunHe/autumn_square.png')" color="#7E3C29"
        borderBottomColor="#7E3C29" boxBorderColor="#D7CECD" btnBJcolor="#BF9E95" hoverBJcolor="#844533">
      </ConvenientService> -->
      <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/ShunHe/autumn_square.png')" color="#7E3C29"
        borderBottomColor="#7E3C29"></GovernmentServices>
      <!-- 直通乡镇 -->
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/ShunHe/autumn_square.png')" color="#7E3C29"
        borderBottomColor="#7E3C29" boxBorderColor="#D7CECD"></ztxzList>
    </div>

  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'ShunHe',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: this.$route.params.mapId || null,  //点位ID
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'顺河彝族乡'
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 获取便民办事
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else {
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //         }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n, '时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  // },
};
</script>
<style scoped>
.ShunHe {
  background: url('../../../../src/assets/img/ShunHe/bg.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.autumn .top_title {
  color: #7E3C29;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #7E3C29;
  height: 12%;
}

.con2 {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.list_item {
  background-color: #F9F9F9;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 78px;
  padding: 0 10px;
  border: 1px solid #EBA970;
  margin-bottom: 20px;
}

.list_item_left {
  font-size: 18px;
  font-weight: bold;
}

.banshi_btn {
  background-color: rgb(234, 182, 134);
  color: rgb(255, 255, 255);
  border: none;
  font-size: 18px;
  font-weight: bold;
  border-radius: 7px;
}

.banshi_btn:hover {
  background-color: #DB7312;
}

.ztxz {
  width: 1200px;
  margin: 0 auto;
  margin-top: 25px
}

.xzlist {
  margin: 20px 0;
  background-color: #F9F9F9;
  border: 1px solid #EBA970;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 100px;
  padding: 0 20px;
}

.xzlist a {
  display: inline-block;
  margin-right: 40px;
  font-size: 16px;
  font-weight: 550;
}</style>